import controller from './subscription.controller';
import template from './subscription.pug';

const SubscriptionComponent = {
  template,
  controller,
};

export default SubscriptionComponent;



// WEBPACK FOOTER //
// ./client/app/subscription/subscription.component.js